import { useConfig } from '@hooks/useConfig';

export const PrivacyPolicy = () => {
  const { privacyPolicy: Policy } = useConfig();
  return <Policy />;
};
